import { _APP_KEY } from "./reducer";

/// <summary>
/// Author: Nelson
/// </summary>
export function setBusy(message) {
    return async dispatch => {
        dispatch({
            type: _APP_KEY['BUSY'],
            message: message
        });
    }
}

/// <summary>
/// Author: Nelson
/// </summary>
export function setIdle() {
    return async dispatch => {
        dispatch({
            type: _APP_KEY['IDLE']
        });
    }
}

/// <summary>
/// Author: Nelson
/// </summary>
export function setHeaderTimer(beginHeaderTimer) {
    return async dispatch => {
        dispatch({
            type: _APP_KEY['TIMER'],
            beginHeaderTimer: beginHeaderTimer
        });
    }
}